module.exports = __webpack_public_path__ + "static/media/azapfy-name.f42ab2f0.png";